import Unit from "@/orders/entities/unit";
import SelectOption from "@/common/ui/presenters/select-option";

/**
 * UnitをOptionに変換する
 */
export default function UnitOption(unit: Unit): SelectOption {
  return {
    text: unit.name,
    value: unit.name
  };
}
